/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleRectangle = createReactComponent("circle-rectangle", "IconCircleRectangle", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M7 10h10v4h-10z", key: "svg-1" }]
]);

export { IconCircleRectangle as default };
//# sourceMappingURL=IconCircleRectangle.js.map
